import { FC, ReactNode } from 'react'
import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
import PerInputNumber, { PerInputNumberProps } from '../custom_components/PerInputNumber'
import PerText from '../custom_components/Text'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type InputNumberProps = FormikFieldProps & PerInputNumberProps & { [key: string]: any; subLabel?: ReactNode }

export const FormikInputNumber: FC<InputNumberProps> = ({ name, validate, minInitialOffset, subLabel, isContractChange, ...restProps }) => {
  return (
    <Field name={name} validate={validate}>
      {({ field: { value }, form: { setFieldValue } }: FieldProps) => (
        <>
          <PerInputNumber
            name={name}
            value={value}
            onChange={(v) => {
              const empty = ''
              if (!isContractChange) {
                setFieldValue(name, (v && !isNaN(v)) || v === 0 ? v : empty)
              } else {
                const fieldMin: number = restProps.min || 0
                if (v === undefined || v === null || v.toString() === empty) {
                  setFieldValue(name, undefined)
                } else {
                  if (isNaN(v)) {
                    if (value) {
                      setFieldValue(name, value)
                    } else {
                      setFieldValue(name, empty)
                    }
                  } else if (v < fieldMin) {
                    if (value === undefined || value === null || value.toString() === '') {
                      if (minInitialOffset !== undefined && minInitialOffset !== null) {
                        if (restProps.step) {
                          setFieldValue(name, Number(minInitialOffset) - restProps.step)
                        } else {
                          setFieldValue(name, minInitialOffset)
                        }
                      } else {
                        setFieldValue(name, empty)
                      }
                    } else {
                      setFieldValue(name, empty)
                    }
                  } else if (v === fieldMin && restProps.step && restProps.step === value) {
                    setFieldValue(name, empty)
                  } else {
                    if (value === undefined || value === null || value.toString() === '') {
                      if (minInitialOffset !== undefined && minInitialOffset !== null) {
                        if (restProps.step && v === restProps.step) {
                          setFieldValue(name, Number(minInitialOffset) + restProps.step)
                        } else {
                          setFieldValue(name, v)
                        }
                      } else {
                        setFieldValue(name, v)
                      }
                    } else {
                      setFieldValue(name, v)
                    }
                  }
                }
              }
              if (restProps.depName) {
                const val = typeof v === 'number' ? restProps.depValue(v) : empty
                setFieldValue(restProps.depName, val)
              }
            }}
            {...restProps}
            disabled={restProps.disabled}
          />
          {subLabel && (
            <PerText mt="xxxs" fontSize="s" fontWeight="thin" color="secondary">
              {subLabel}
            </PerText>
          )}
        </>
      )}
    </Field>
  )
}
